<template>
  <div class="border border-[1px] border-t-[#3333331a] border-b-[#3333331a]">
    <div class="wrapper flex justify-center">
      <template
        v-for="page in accountPages"
        :key="page.title"
      >
        <nuxt-link
          v-if="!page.old"
          :to="page.to"
          exact
          class="account-menu__link"
          exact-active-class="account-menu__link--active"
          :class="{'--has-mark': getProductsCountByState('SECOND_EDITION')}"
        >
          {{ page.title }}
        </nuxt-link>

        <a
          v-else
          :href="page.href"
          class="account-menu__link"
        >{{ page.title }}</a>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { getProductsCountByState } = useProductCounts();

const accountPages = [
  { title: t('components.account.AccountMenu.profile'), to: { name: 'account' } },
  { title: t('components.account.AccountMenu.products'), to: { name: 'account-products', query: { state: 'PUBLISHED' } } },
  { title: t('components.account.AccountMenu.sales'), href: '/account/sales', old: true },
  { title: t('components.account.AccountMenu.favorites'), href: '/account/favorites', old: true },
  { title: t('components.account.AccountMenu.orders'), href: '/account/orders', old: true },
];
</script>

<style scoped lang="scss">
@tailwind components;

@layer components {
  .account-menu {
    &__link {
      @apply relative flex h-[72px] text-[#33333366] hover:text-black px-[21px] py-[27px] text-lg items-center uppercase font-semibold tracking-wider;

      &--active {
        @apply text-black;

        &::after {
          content: '';
          @apply absolute bottom-[-1px] left-0 w-full h-0.5 bg-[#333];
        }
      }

      &.--has-mark {
        &::before {
          @apply w-[7px] h-[7px] top-[15px] right-[5px];
        }
      }
    }
  }

  .--has-mark {
    @apply relative;

    &::before {
      content: '';
      @apply absolute w-[5px] h-[5px] bg-[#f00] top-[-1px] right-[-5px] rounded-full;
    }
  }
}
</style>
